import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any, isMobile: boolean) => {
  const permissionList = data?.permissionDetails
    .map((item) => ({ ...item, permissionCategory: item.permissionFlag }))
    .filter((item) => item.permissionCategory === 'Y')
  if (isMobile) {
    return permissionList.filter(
      (item) => item.permissionCode !== 'CONFIG_OFFERS' && item.permissionCode !== 'VIEW_CRED_API',
    )
  }
  return permissionList
}
const getUserPermissionList = (tokens: any, reqBody: any, isMobile: boolean) => {
  const request: Request<{}> = {
    config: sitConfig(tokens),
    apiPath: APIEndPoints.getUserPermissions,
    method: 'POST',
    cache: false,
    body: reqBody,
  }
  return executeRequest(request).then(({ data }) => {
    return responseParser(data, isMobile)
  })
}

export { getUserPermissionList }
